// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W10f","type":"styles_type__384qM","choices":"styles_choices__-0BMV"};